import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import i18n from '@pureartisan/simple-i18n'
import shallow from 'zustand/shallow'
import {
  Snackbar,
  Slide,
  Box,
  Typography,
  IconButton,
} from '@material-ui/core'
import useStore from '../store'
import { Close } from '@material-ui/icons'

const DEFAULT_AUTODISMISS_TIMEOUT = 6000

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: '#f7d622',
      minWidth: 'auto',
      padding: '18px 36px 18px 18px',
    },
    '& .MuiSnackbarContent-message': {
      padding: 0,
    },
  },
  button: {
    position: 'absolute',
    right: 0,
    top: 0,
    '& svg': {
      width: '20px',
      height: '20px',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}))

const Notifications = () => {
  const { notification, setStoreValues } = useStore(
    state => ({
      notification: state.notification,
      setStoreValues: state.setStoreValues,
    }),
    shallow,
  )
  const classes = useStyles()

  if (!notification) return null

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setStoreValues({ notification: null })
  }

  const Notifications = Array.isArray(notification)
    ? notification
    : [notification]
  const Message = (
    <Box>
      {Notifications.map(n => (
        <Typography key={n}>{i18n.translate(n)}</Typography>
      ))}
      <IconButton
        classes={{ root: classes.button }}
        disableRipple
        onClick={handleClose}
      >
        <Close />
      </IconButton>
    </Box>
  )

  return (
    <Snackbar
      classes={{ root: classes.root }}
      open={!!notification}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={DEFAULT_AUTODISMISS_TIMEOUT}
      onClose={handleClose}
      message={Message}
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'up', timeout: 300 }}
    />
  )
}

export default Notifications
